<ng-container *ngIf="page_summary_data_loaded">

	<div class="new-summary-section">
		<ng-container *ngIf="type == 'Upside Opportunities'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{commonService.abbreviateNumber(page_summary_data.total_leads)}}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>
			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Retention Opportunities'">
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_clients) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.invested_aum) }}</p>
					<p class="each-new-summary-section-label">Invested AUM</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.upside_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_expected_loss) }}</p>
					<p class="each-new-summary-section-label">Total Estimated Loss</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.retained_clients) }}</p>
					<p class="each-new-summary-section-label">Retained Opportunities</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.churn_clients) }}</p>
					<p class="each-new-summary-section-label">Churn Opportunities</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_actual_loss) }}</p>
					<p class="each-new-summary-section-label">Actual Loss</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients'"> -->
		<ng-container *ngIf="type == 'Bank Customers to Investment Clients'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'New Prospects'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] == 5 || user_details.role.business_area[0] == 6">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] == 7 || user_details.role.business_area[0] == 8">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ page_summary_data.total_opportunity }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] == 5 || user_details.role.business_area[0] == 6">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-count" *ngIf="user_details.role.business_area[0] == 7 || user_details.role.business_area[0] == 8">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ page_summary_data.converted_opportunity }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients'"> -->
		<ng-container *ngIf="type == 'Bank Customers to Deposit Clients'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Bank Customers to Lending Clients'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<!-- <p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p> -->
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{page_summary_data.total_opportunity }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<!-- <p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p> -->
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ page_summary_data.converted_opportunity }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Bank Customers to Insurance Clients'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2 && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<!-- <p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p> -->
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ page_summary_data.total_opportunity }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<!-- <p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p> -->
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ page_summary_data.converted_opportunity }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Non Customers'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container *ngIf="stepper_stage.order == 2">
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('active')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.active_interactions) }}</p>
					<p class="each-new-summary-section-label">Active Interactions</p>
				</div>

				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getInteractionsData('inactive')">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.inactive_interactions) }}</p>
					<p class="each-new-summary-section-label">Pending Interactions</p>
				</div>
			</ng-container>

			<ng-container *ngIf="stepper_stage.position != 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<ng-container *ngIf="stepper_stage.position == 'last'">
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.converted_leads) }}</p>
					<p class="each-new-summary-section-label">Converted Opportunities</p>
				</div>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_opportunity) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<!-- New MAGI Tab Section -->

		<ng-container *ngIf="type == 'Upside Opportunities MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{commonService.abbreviateNumber(page_summary_data.total_leads)}}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Retention Opportunities MAGI'">
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_clients) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.invested_aum) }}</p>
					<p class="each-new-summary-section-label">Invested AUM</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.upside_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
				<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_expected_loss) }}</p>
					<p class="each-new-summary-section-label">Total Estimated Loss</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section each-sales-process-summary-results-section" [ngClass]="{'each-sales-process-summary-retention-section': stepper_stage.position == 'last', 'retention-interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Bank Customers to Investment Clients MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'New Prospects MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>

			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Bank Customers to Deposit Clients MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Non Customers MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Advisor Manager Bank Customers to Investment Clients MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Advisor Manager New Prospects MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>

			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="ach-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Advisor Manager Bank Customers to Deposit Clients MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Advisor Manager Non Customers MAGI'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}" (click)="getInteractionsData('all')">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team Bank Customers to Investment Clients Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team New Prospects Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team New Prospects - Investments Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team Bank Customers to Deposit Clients Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team  Non Customers Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team  New Prospects - Deposits Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team Bank Customers to Lending Clients Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team  New Prospects - Lending Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team Bank Customers to Insurance Clients Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team  New Prospects - Insurance Unassigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}</p>
				<p class="each-new-summary-section-label">Leads</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.avg_wallet_share }}</p>
				<p class="each-new-summary-section-label">Additional Book Value</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.responses_received) }}</p>
					<p class="each-new-summary-section-label">Responded</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_analysis" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">View Analysis</p>
			</div>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team Bank Customers to Investment Clients Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team New Prospects Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team New Prospects - Investments Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team Bank Customers to Deposit Clients Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team  Non Customers Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team  New Prospects - Deposits Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team Bank Customers to Lending Clients Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team  New Prospects - Lending Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

    <ng-container *ngIf="type == 'Marketing Team Bank Customers to Insurance Clients Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

		<ng-container *ngIf="type == 'Marketing Team  New Prospects - Insurance Assigned'">
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2, 'pointer': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ commonService.abbreviateNumber(page_summary_data.total_assigned) }}</p>
				<p class="each-new-summary-section-label">Total Assigned</p>
			</div>

			<ng-container>
				<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}</p>
					<p class="each-new-summary-section-label">Predicted Potential Opportunity</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<p class="each-new-summary-section-count">{{ page_summary_data.converted }}</p>
				<p class="each-new-summary-section-label">Converted Opportunities</p>
			</div>
			<ng-container>
				<div class="each-new-summary-section pointer" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}" (click)="getRespondedOpportunities()">
					<p class="each-new-summary-section-count">{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.converted_aum) }}</p>
					<p class="each-new-summary-section-label">Converted AUM</p>
				</div>
			</ng-container>
			<div class="each-new-summary-section" [ngClass]="{'each-sales-process-summary-results-section': stepper_stage.position == 'last', 'interaction-summary-section': stepper_stage.order == 2}">
				<div class="each-new-summary-section-switch">
					<mat-slide-toggle class="graph-action-switch" [(ngModel)]="show_graphical_representation" (change)="toggleGraphs()" ></mat-slide-toggle>
				</div>
				<p class="each-new-summary-section-label">Graphical Representation</p>
			</div>
		</ng-container>

	</div>

	<!-- <ng-container *ngIf="type == 'Marketing Team Bank Customers to Investment Clients Unassigned' || type == 'Marketing Team New Prospects Unassigned' || type == 'Marketing Team Bank Customers to Deposit Clients Unassigned' || type == 'Marketing Team  Non Customers Unassigned' || type == 'Upside Opportunities MAGI' || type == 'Retention Opportunities MAGI' || type == 'Bank Customers to Investment Clients MAGI' || type == 'New Prospects MAGI' || type == 'Bank Customers to Deposit Clients MAGI' || type == 'Non Customers MAGI'">
		<app-agent-one-view [type]="type"></app-agent-one-view>
	</ng-container> -->

	<!-- <ng-container *ngIf="type == 'Upside Opportunities MAGI' || type == 'Retention Opportunities MAGI' || type == 'Bank Customers to Investment Clients MAGI' || type == 'New Prospects MAGI' || type == 'Bank Customers to Deposit Clients MAGI' || type == 'Non Customers MAGI' || type == 'Marketing Team Bank Customers to Investment Clients Unassigned' || type == 'Marketing Team New Prospects Unassigned' || type == 'Marketing Team Bank Customers to Deposit Clients Unassigned' || type == 'Marketing Team  Non Customers Unassigned' || type == 'Upside Opportunities MAGI' || type == 'Retention Opportunities MAGI' || type == 'Bank Customers to Investment Clients MAGI' || type == 'New Prospects MAGI' || type == 'Bank Customers to Deposit Clients MAGI' || type == 'Non Customers MAGI'">
		<app-agent-three-view [type]="type"></app-agent-three-view>
	</ng-container> -->

	<ng-container *ngIf="show_analysis">
		<!-- <app-stage-process-analysis [opp_type]="analysis_type" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis> -->
		<app-stage-process-analysis-v2 [opp_type]="analysis_type" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis-v2>
	</ng-container>

	<div class="page-graphs-section" *ngIf="show_graphical_representation">
		<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="graphSlideConfig">
			<div ngxSlickItem class="each-summary-graph-block" *ngFor="let graph of page_summary_data['graphs_list']">
				<ng-container>
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>{{graph.name}}</span>
					</div>
					<div class="each-summary-graph-content">
						<ng-container *ngIf="graph.type != 'map'">
							<div [attr.id]="graph.id"></div>
						</ng-container>
						<!-- <ng-container *ngIf="graph.type == 'map'">
							<highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true" style="width: 100%; height: 295px; display: block"></highcharts-chart>
						</ng-container> -->
					</div>
				</ng-container>
			</div>
		</ngx-slick-carousel>
	</div>

	<div class="summary-table-data-section">
		<div class="summary-table-section">
			<div>
				<div class="new-table-v2-overflow">
					<div class="new-table-heading-section">
						<div class="my-4">
							<ng-container *ngFor="let graph_filter of page_summary_data['graphs_list']">
								<ng-container *ngIf="graph_filter.type != 'tree'">
									<ng-container *ngIf="graph_filter.filter_key[0] == 'yearly_filter'">
										<span class="new-filter-tag" *ngIf="graph_filter[graph_filter.filter_key[0]] && graph_filter[graph_filter.filter_key[0]] != '' && graph_filter[graph_filter.filter_key[0]] != null">
											{{graph_filter[graph_filter.filter_key_name[0]]}}
											<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="
												graph_filter[graph_filter.filter_key[0]] = '';
												graph_filter[graph_filter.filter_key_name[0]] = ''; current_pagination_page = 1;
												disable_future_client_data_selection = false;
												getTableData()"
											/>
										</span>
									</ng-container>
									<ng-container *ngIf="graph_filter.filter_key[0] != 'yearly_filter'">
										<span class="new-filter-tag" *ngIf="graph_filter[graph_filter.filter_key[0]] && graph_filter[graph_filter.filter_key[0]] != '' && graph_filter[graph_filter.filter_key[0]] != null">
											{{graph_filter[graph_filter.filter_key_name[0]]}}
											<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="
												graph_filter[graph_filter.filter_key[0]] = '';
												graph_filter[graph_filter.filter_key_name[0]] = ''; current_pagination_page = 1;
												getTableData()"
											/>
										</span>
									</ng-container>
								</ng-container>
								<ng-container *ngIf="graph_filter.type == 'tree'">
									<span class="new-filter-tag" *ngIf="graph_filter[graph_filter.filter_key[0]] && graph_filter[graph_filter.filter_key[0]] && graph_filter[graph_filter.filter_key[0]] != '' && graph_filter[graph_filter.filter_key[0]] != null">
										{{graph_filter[graph_filter.filter_key_name[0]]}}
										<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="
										 	graph_filter[graph_filter.filter_key[0]] = '';
											graph_filter[graph_filter.filter_key_name[0]] = ''; current_pagination_page = 1;
											getTableData()"
										/>
									</span>

									<span class="new-filter-tag" *ngIf="graph_filter[graph_filter.filter_key[1]]&& graph_filter[graph_filter.filter_key[1]] && graph_filter[graph_filter.filter_key[1]] != '' && graph_filter[graph_filter.filter_key[1]] != null">
										{{graph_filter[graph_filter.filter_key_name[1]]}}
										<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="
										 	graph_filter[graph_filter.filter_key[1]] = '';
											graph_filter[graph_filter.filter_key_name[1]] = ''; current_pagination_page = 1;
											getTableData()"
										/>
									</span>
								</ng-container>
							</ng-container>

							<ng-container *ngIf="stepper_stage.order == 2">
								<span class="new-filter-tag" *ngIf="interactions_data_type != 'all'">
									{{interactions_data_type}}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="interactions_data_type = 'all'; current_pagination_page = 1; getTableData()" />
								</span>
							</ng-container>

							<ng-container>
								<span class="new-filter-tag" *ngIf="responded_type != 'all'">
									{{responded_type}}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)="responded_type = 'all'; current_pagination_page = 1; getTableData()" />
								</span>
							</ng-container>

							<ng-container>
								<span class="new-filter-tag" *ngIf="opp_breakdown_id != ''">
									{{ opp_breakdown_name }}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_breakdown_id = ''; opp_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
									/>
								</span>
								<span class="new-filter-tag" *ngIf="rules_breakdown_id != ''">
									{{ rules_breakdown_name }}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" rules_breakdown_id = ''; rules_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
									/>
								</span>
								<span class="new-filter-tag" *ngIf="ai_breakdown_id != ''">
									{{ ai_breakdown_name }}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" ai_breakdown_id = ''; ai_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
									/>
								</span>

								<span class="new-filter-tag" *ngIf="common_breakdown_id != ''">
									{{ common_breakdown_name }}
									<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" common_breakdown_id = ''; common_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
									/>
								</span>

							</ng-container>
						</div>
						<span>AI Explainability</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section">
							  <div class="module-page-information-section" *ngFor="let section of ai_explainability_sections">
								<div class="each-module-page-information-section">
								  <p class="each-module-page-information-heading">{{section.name}}</p>
								</div>
								<ng-container *ngIf="section.sub_sections">
								  <ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
									<div class="each-module-page-information-sub-section">
									  <p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
									  <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>

									  <ng-container *ngIf="sub_section.sub_sections">
										<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
										  <p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
										  <p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
										</div>
									  </ng-container>

									</div>
								  </ng-container>
								</ng-container>
							  </div>
							</div>
						  </div>
						<div class="new-table-actions ml-4">
							<div class="each-action-section search-input-section" *ngIf="show_search">
								<input type="text" placeholder="Search" class="search-input" [(ngModel)]="search_key" (input)="current_pagination_page = 1; getTableData()" />
								<span class="search-input-close" (click)=" show_search = false; search_key = '';current_pagination_page = 1; getTableData()">&times;</span >
							</div>
							<div class="each-action-section search-icon" *ngIf="!show_search" (click)="show_search = true">
								<img src="assets/search.png" class="button-icon" />
								<span>Search</span>
							</div>
							<div class="each-action-section dynamic-columns-section">
								<img src="assets/column-filter.png" class="button-icon" (click)="show_toggle_columns = !show_toggle_columns" />
								<div class="dynamic-columns" *ngIf="show_toggle_columns">
									<div class="dynamic-column-heading-section">
										<span>Filter Columns</span>
										<span class="columns-close" (click)="show_toggle_columns = false" >&times;</span>
									</div>
									<div class="dynamic-column-content">
										<div class="each-column-section" *ngFor="let column of table_columns">
											<mat-checkbox [checked]="column.checked == true" (change)="column.checked = !column.checked" >{{ column.name }}</mat-checkbox>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="alphabets-filter-section">
							<p class="new-each-filter-alphabet" [ngClass]="{ 'new-filter-alphabet-selected': alphabet == selected_alphabet }" *ngFor="let alphabet of alphabets_array" (click)=" current_pagination_page = 1; selected_alphabet = alphabet; getTableData() " style="margin-bottom: 8px !important"> {{ alphabet }}</p>
							<p class="clear-filter-alphabet" (click)=" current_pagination_page = 1; selected_alphabet = ''; getTableData() " > Clear</p>
						</div>
						<ng-container *ngIf="!disable_future_client_data_selection">
							<div class="move-records-section" *ngIf="stepper_stage.position != 'last'">
								<!-- <ng-container *ngIf="stepper_stage.order == 2">
									<button class="move-records-button" (click)="openSendProposalModal('Send')">Send Proposal</button>
								</ng-container> -->
								<!-- <ng-container *ngIf="stepper_stage.order == 3">
									<button class="move-records-button" (click)="openSendProposalModal('Resend')">Resend Proposal</button>
								</ng-container> -->
								<!-- <ng-container *ngIf="stepper_stage.order == 3 && type != 'Retention Opportunities'">
									<button class="move-records-button" (click)="openCloseDealModal()">Close Deal</button>
								</ng-container> -->
								<!-- <ng-container *ngIf="(stepper_stage.order == 2 || stepper_stage.order == 3) && type == 'Retention Opportunities'">
									<button class="move-records-button" (click)="openChangeOutcomeModal()">Change Outcome</button>
								</ng-container> -->
								<!-- <ng-container *ngIf="(stepper_stage.order == 3) && type == 'Retention Opportunities'">
									<button class="move-records-button" (click)="openChangeOutcomeModal()">Change Outcome</button>
								</ng-container> -->
								<!-- <button class="move-records-button" (click)="openMoveRecordModal()">Move to Stage</button> -->
								<!-- <span class="page-modal-input-label" *ngIf="selected_table_data.length > 0">{{selected_table_data.length}} Record(s) Selected</span> -->
								<!-- <span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more clients to move</span> -->
								<!-- <span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more clients</span> -->
							</div>
							<div class="move-records-section" *ngIf="(type == 'Marketing Team Bank Customers to Investment Clients Unassigned') || (type == 'Marketing Team New Prospects Unassigned') || (type == 'Marketing Team New Prospects - Investments Unassigned') || (type == 'Marketing Team Bank Customers to Deposit Clients Unassigned') || (type == 'Marketing Team Non Customers Unassigned') || (type == 'Marketing Team New Prospects - Deposits Unassigned') || (type == 'Marketing Team Bank Customers to Lending Clients Unassigned') || (type == 'Marketing Team New Prospects - Lending Unassigned') || (type == 'Marketing Team Bank Customers to Insurance Clients Unassigned') || (type == 'Marketing Team New Prospects - Insurance Unassigned')">
								<!-- <button class="move-records-button" (click)="openAssignAdvisorModal()">Assign Advisor</button> -->
								<button class="move-records-button" (click)="openAssignAdvisorModal()">Assign</button>
								<button class="move-records-button" (click)="openCreateAdvisorTeamModal()">Assign Advisor Team</button>
								<span class="page-modal-input-label" *ngIf="selected_table_data.length > 0">{{selected_table_data.length}} Record(s) Selected</span>
								<span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more records to assign</span>
							</div>
						</ng-container>
						<div class="new-table-v2-overflow">
							<table class="new-table-v2">
								<thead>
									<tr>

										<th appColumnResizable>
											<!-- <ng-container *ngIf="type != 'Upside Opportunities MAGI' && type != 'Retention Opportunities MAGI' && type != 'Bank Customers to Investment Clients MAGI' && type != 'New Prospects MAGI' && type != 'Bank Customers to Deposit Clients MAGI' && type != 'Non Customers MAGI'">
												<ng-container *ngIf="!disable_future_client_data_selection">
													<div class="record-selection-section" *ngIf="stepper_stage.position != 'last'">
														<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
													</div>
												</ng-container>
											</ng-container> -->
											<ng-container *ngIf="(type == 'Marketing Team Bank Customers to Investment Clients Unassigned') || (type == 'Marketing Team New Prospects Unassigned') || (type == 'Marketing Team New Prospects - Investments Unassigned') || (type == 'Marketing Team Bank Customers to Deposit Clients Unassigned') || (type == 'Marketing Team Non Customers Unassigned') || (type == 'Marketing Team New Prospects - Deposits Unassigned') || (type == 'Marketing Team Bank Customers to Lending Clients Unassigned') || (type == 'Marketing Team New Prospects - Lending Unassigned') || (type == 'Marketing Team Bank Customers to Insurance Clients Unassigned') || (type == 'Marketing Team New Prospects - Insurance Unassigned')">
												<ng-container *ngIf="!disable_future_client_data_selection">
													<div class="record-selection-section">
														<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
													</div>
												</ng-container>
											</ng-container>
											Actions
										</th>
										<!-- <ng-container *ngIf="type != 'Upside Opportunities MAGI' && type != 'Retention Opportunities MAGI' && type != 'Bank Customers to Investment Clients MAGI' && type != 'New Prospects MAGI' && type != 'Bank Customers to Deposit Clients MAGI' && type != 'Non Customers MAGI' && type != 'Advisor Manager Bank Customers to Investment Clients MAGI' && type != 'Advisor Manager New Prospects MAGI' && type != 'Advisor Manager Bank Customers to Deposit Clients MAGI' && type != 'Advisor Manager Non Customers MAGI' && type != 'Marketing Team Bank Customers to Investment Clients Unassigned' && type != 'Marketing Team New Prospects Unassigned' && type != 'Marketing Team Bank Customers to Deposit Clients Unassigned' && type != 'Marketing Team Non Customers Unassigned' && type != 'Marketing Team Bank Customers to Investment Clients Assigned' && type != 'Marketing Team New Prospects Assigned' && type != 'Marketing Team Bank Customers to Deposit Clients Assigned' && type != 'Marketing Team Non Customers Assigned'">
											<th appColumnResizable *ngIf="stepper_stage.position != 'last'">Activities</th>
										</ng-container> -->
										<!-- <ng-container *ngIf="type == 'Upside Opportunities MAGI' || type == 'Retention Opportunities MAGI' || type == 'Bank Customers to Investment Clients MAGI' || type == 'New Prospects MAGI' || type == 'Bank Customers to Deposit Clients MAGI' || type == 'Non Customers MAGI' || type == 'Advisor Manager Bank Customers to Investment Clients MAGI' || type == 'Advisor Manager New Prospects MAGI' || type == 'Advisor Manager Bank Customers to Deposit Clients MAGI' || type == 'Advisor Manager Non Customers MAGI' || type == 'Marketing Team Bank Customers to Investment Clients Unassigned' || type == 'Marketing Team New Prospects Unassigned' || type == 'Marketing Team Bank Customers to Deposit Clients Unassigned' || type == 'Marketing Team Non Customers Unassigned'">
											<th appColumnResizable>Activities</th>
										</ng-container> -->
										<ng-container *ngIf="stepper_stage.position != 'last'">
											<th appColumnResizable *ngIf="type != 'Marketing Team Bank Customers to Investment Clients Assigned' && type != 'Marketing Team New Prospects Assigned' && type != 'Marketing Team New Prospects - Investments Assigned' && type != 'Marketing Team Bank Customers to Deposit Clients Assigned' && type != 'Marketing Team New Prospects - Deposits Assigned' && type != 'Marketing Team Bank Customers to Lending Clients Assigned' && type != 'Marketing Team New Prospects - Lending Assigned' && type != 'Marketing Team Bank Customers to Insurance Clients Assigned' && type != 'Marketing Team New Prospects - Insurance Assigned'">Activities</th>
											<!-- <th appColumnResizable *ngIf="type == 'Marketing Team Bank Customers to Investment Clients Unassigned' || type == 'Marketing Team New Prospects Unassigned'">Activities</th> -->
										</ng-container>
										<!-- <th appColumnResizable *ngIf="(stepper_stage.position != 'last') && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">Documents</th> -->
										<th appColumnResizable *ngIf="stepper_stage.position == 'last'">Products</th>

										<ng-container *ngIf="type == 'Upside Opportunities' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<ng-container *ngIf="type == 'Retention Opportunities' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients' && stepper_stage.position == 'last'"> -->
										<ng-container *ngIf="type == 'Bank Customers to Investment Clients' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<ng-container *ngIf="type == 'New Prospects' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients' && stepper_stage.position == 'last'"> -->
										<ng-container *ngIf="type == 'Bank Customers to Deposit Clients' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

                    					<ng-container *ngIf="type == 'Bank Customers to Lending Clients' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

                    					<ng-container *ngIf="type == 'Bank Customers to Insurance Clients' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<ng-container *ngIf="type == 'Non Customers' && stepper_stage.position == 'last'">
											<th appColumnResizable>Outcome Status</th>
                  							<th appColumnResizable>Outcome Comments</th>
										</ng-container>

										<!-- <ng-container *ngFor="let column of table_columns">
											<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
										</ng-container> -->

										<ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
											<ng-container *ngSwitchCase="'trigger'">
												<th appColumnResizable *ngIf="column.checked" style="width: 350px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'trigger_condition'">
												<th appColumnResizable *ngIf="column.checked" style="width: 500px;">{{ column.name }}</th>
											</ng-container>

											<ng-container *ngSwitchCase="'opportunity'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'total_estimated_loss'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'predicted_closure_days'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'recommended_products'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>
											<ng-container *ngSwitchCase="'preferred_channel'">
												<th appColumnResizable *ngIf="column.checked" style="width: 250px;">{{ column.name }}</th>
											</ng-container>

											<ng-container *ngSwitchDefault>
												<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
											</ng-container>
										</ng-container>
									</tr>
								</thead>
								<ng-container *ngIf="table_data_loaded">
									<tbody *ngIf="table_data.length > 0">
										<ng-container *ngFor="let client of table_data | paginate : { id: 'interactions-data', itemsPerPage: pagination_records_limit, currentPage: current_pagination_page, totalItems: total_pagination_records }; let clientIndex = index">
											<tr>
												<td>
													<!-- <ng-container *ngIf="type != 'Upside Opportunities MAGI' && type != 'Retention Opportunities MAGI' && type != 'Bank Customers to Investment Clients MAGI' && type != 'New Prospects MAGI' && type != 'Bank Customers to Deposit Clients MAGI' && type != 'Non Customers MAGI'">
														<ng-container *ngIf="!disable_future_client_data_selection">
															<div class="record-selection-section" *ngIf="stepper_stage.position != 'last'">
																<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
															</div>
														</ng-container>
													</ng-container> -->

													<ng-container *ngIf="(type == 'Marketing Team Bank Customers to Investment Clients Unassigned') || (type == 'Marketing Team New Prospects Unassigned') || (type == 'Marketing Team New Prospects - Investments Unassigned') || (type == 'Marketing Team Bank Customers to Deposit Clients Unassigned') || (type == 'Marketing Team Non Customers Unassigned') || (type == 'Marketing Team New Prospects - Deposits Unassigned') || (type == 'Marketing Team Bank Customers to Lending Clients Unassigned') || (type == 'Marketing Team New Prospects - Lending Unassigned') || (type == 'Marketing Team Bank Customers to Insurance Clients Unassigned') || (type == 'Marketing Team New Prospects - Insurance Unassigned')">
														<ng-container *ngIf="!disable_future_client_data_selection">
															<div class="record-selection-section">
																<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
															</div>
														</ng-container>
													</ng-container>



													<!-- <img src="assets/view-tasks.png" class="client-table-icon" (click)="openClientDataModal(client)" /> -->
													<img src="assets/view-tasks.png" class="client-table-icon" (click)="showUserProfile(client)" style="margin-right: 4px;" [matTooltip]="'View Details'" />

													<ng-container *ngIf="user_role != 'Marketing Team'">
														<!-- <img src="assets/add-activity.png" class="client-table-icon" *ngIf="stepper_stage.order == 2" (click)="addManualTask(client, clientIndex)" style="margin-right: 4px;" [matTooltip]="'Add Activity'" /> -->
														<img src="assets/add-activity.png" class="client-table-icon" *ngIf="stepper_stage.position != 'last'" (click)="addManualTask(client, clientIndex)" style="margin-right: 4px;" [matTooltip]="'Add Activity'" />

														<!-- <img src="assets/send-proposal.png" class="client-table-icon" *ngIf="stepper_stage.order == 2" (click)="openSendProposalModal('Send', client)" style="margin-right: 4px;" [matTooltip]="'Send Document'" /> -->
														<img src="assets/send-proposal.png" class="client-table-icon" *ngIf="stepper_stage.position != 'last'" (click)="openSendProposalModal('Send', client)" style="margin-right: 4px;" [matTooltip]="'Send Document'" />

														<!-- <img src="assets/resend-proposal.png" class="client-table-icon" *ngIf="stepper_stage.order == 3" (click)="openSendProposalModal('Resend', client)" style="margin-right: 4px;" [matTooltip]="'Resend Proposal'" /> -->

														<!-- <img src="assets/close-deal.png" class="client-table-icon" *ngIf="stepper_stage.order == 3 && type != 'Retention Opportunities'" (click)="openCloseDealModal(client)" style="margin-right: 4px;" [matTooltip]="'Close Deal'" /> -->
														<!-- <img src="assets/close-deal.png" class="client-table-icon" *ngIf="(stepper_stage.order == 3) && type == 'Retention Opportunities'" (click)="openChangeOutcomeModal(client)" style="margin-right: 4px;" [matTooltip]="'Change Outcome'" /> -->

														<img src="assets/close-deal.png" class="client-table-icon" *ngIf="stepper_stage.position != 'last' && type != 'Retention Opportunities'" (click)="openCloseDealModal(client)" style="margin-right: 4px;" [matTooltip]="'Capture Results'" />
														<img src="assets/close-deal.png" class="client-table-icon" *ngIf="(stepper_stage.position != 'last') && type == 'Retention Opportunities'" (click)="openChangeOutcomeModal(client)" style="margin-right: 4px;" [matTooltip]="'Capture Results'" />

														<img src="assets/ic-blue-upsell.png" class="client-table-icon" (click)="openAddOpportunityModal(client)" [matTooltip]="'Add to Upside Opportunities'" *ngIf="client.advisor_recommendation == true && stepper_stage.position != 'last'" style="margin-right: 4px;" />
													</ng-container>
													<ng-container>
														<img
															src="assets/sync-icon.png"
															class="client-table-icon"
															*ngIf="user_details.Salesforce_connected && !salesforce_sync_loader"
															(click)="salesforceSync(client)"
															[matTooltip]="'Sync Activities'"
															style="margin-right: 4px;"
														/>
														<img
															src="assets/sync-icon.png"
															class="client-table-icon"
															*ngIf="user_details.Salesforce_connected && salesforce_sync_loader"
															[matTooltip]="'Sync Activities'"
															style="margin-right: 4px;"
														/>
													</ng-container>
													<img src="assets/exclamation-icon.png" class="client-table-icon" *ngIf="client.trigger_status == 'Inactive'" [matTooltip]="client.trigger_description" />

												</td>
												<td *ngIf="type != 'Marketing Team Bank Customers to Investment Clients Assigned' && type != 'Marketing Team New Prospects Assigned' && type != 'Marketing Team New Prospects - Investments Assigned' && type != 'Marketing Team Bank Customers to Deposit Clients Assigned' && type != 'Marketing Team New Prospects - Deposits Assigned' && type != 'Marketing Team Bank Customers to Lending Clients Assigned' && type != 'Marketing Team New Prospects - Lending Assigned' && type != 'Marketing Team Bank Customers to Insurance Clients Assigned' && type != 'Marketing Team New Prospects - Insurance Assigned'">
													<img src="assets/ic-activities.png" class="client-table-icon" (click)="toggleActivityView(clientIndex)" />
												</td>

												<!-- <td *ngIf="(stepper_stage.position != 'last') && (selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
													<img src="assets/ic-activities.png" class="client-table-icon" (click)="toggleProposalView(clientIndex)" />
												</td> -->

                        						<ng-container *ngIf="type == 'Upside Opportunities' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

												<ng-container *ngIf="type == 'Retention Opportunities' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'new-leads-activity-status': client.attrition_status == 'Retained', 'activity-status-completed': client.attrition_status == 'Retained, Upside', 'activity-status-pending': client.attrition_status == 'Likely to Switch Advisor'}">{{ client.attrition_status }}</span>
													</td>
													<!-- <td>{{ client.attrition_comments }}</td> -->
													<td>
														<p [innerHTML]="client.attrition_comments"></p>
													</td>
												</ng-container>

												<!-- <ng-container *ngIf="type == 'Institutional Customers to Investment Clients' && stepper_stage.position == 'last'"> -->
												<ng-container *ngIf="type == 'Bank Customers to Investment Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

												<ng-container *ngIf="type == 'New Prospects' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

												<!-- <ng-container *ngIf="type == 'Institutional Customers to Deposit Clients' && stepper_stage.position == 'last'"> -->
												<ng-container *ngIf="type == 'Bank Customers to Deposit Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

                        <ng-container *ngIf="type == 'Bank Customers to Lending Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

                        <ng-container *ngIf="type == 'Bank Customers to Insurance Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

												<ng-container *ngIf="type == 'Non Customers' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<!-- <td>{{ client.conversion_comments }}</td> -->
													<td>
														<p [innerHTML]="client.conversion_comments"></p>
													</td>
												</ng-container>

												<!-- <ng-container *ngIf="type == 'Upside Opportunities' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<td>{{ client.conversion_comments }}</td>
												</ng-container>

												<ng-container *ngIf="type == 'Retention Opportunities' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'new-leads-activity-status': client.attrition_status == 'Retained', 'activity-status-completed': client.attrition_status == 'Retained, Upside', 'activity-status-pending': client.attrition_status == 'Likely to Switch Advisor'}">{{ client.attrition_status }}</span>
													</td>
													<td>{{ client.attrition_comments }}</td>
												</ng-container>

												<ng-container *ngIf="type == 'Institutional Customers to Investment Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<td>{{ client.conversion_comments }}</td>
												</ng-container>

												<ng-container *ngIf="type == 'Institutional Customers to Deposit Clients' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<td>{{ client.conversion_comments }}</td>
												</ng-container>

												<ng-container *ngIf="type == 'Non Customers' && stepper_stage.position == 'last'">
													<td>
														<span [ngClass]="{'need-attention-activity-status': client.conversion_status_name == 'Not - Interested', 'activity-status-completed': client.conversion_status_name == 'Purchased', 'activity-status-progress': client.conversion_status_name == 'Pending', 'activity-status-pending': client.conversion_status_name == 'Next Cycle'}">{{ client.conversion_status_name }}</span>
													</td>
													<td>{{ client.conversion_comments }}</td>
												</ng-container> -->

												<ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
													<ng-container *ngSwitchCase="'advisor_status'">
														<td *ngIf="column.checked">
															<p class="status-tag completed-status">
																{{ client.advisor_status }}
															</p>
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'ai_rank'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
                          <ng-container *ngSwitchCase="'campaign_segment'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
                          <ng-container *ngSwitchCase="'campaign_action'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															<mat-select class="coaching-plan-training-status-input" [(ngModel)]="client.campaign_action" (selectionChange)="changeCampaignAction(client)" [readOnly]="client.campaign_action != ''" [disabled]="client.campaign_action != ''">
                                  <mat-option [value]="''" >Select Action</mat-option>
                                  <mat-option [value]="'Next Campaign'" >Next Campaign</mat-option>
                                  <mat-option [value]="'Assign to Call Center'" >Assign to Call Center</mat-option>
                                  <mat-option [value]="'Send a follow up mail'" >Send a follow up mail</mat-option>
                              </mat-select>
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'risk_rank'">
														<td class="highlight-table-cell" *ngIf="column.checked">
														  {{ getKey(client, column) }}
														</td>
													  </ng-container>
													<ng-container *ngSwitchCase="'opportunity'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'total_estimated_loss'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'predicted_wallet_share_growth'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'predicted_closure_days'">
														<td class="highlight-table-cell" *ngIf="column.checked">
															{{ getKey(client, column) }} Day(s)
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'recommended_products'">
														<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
													<ng-container *ngSwitchCase="'preferred_channel'">
														<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getKey(client, column)">
															{{ getKey(client, column) }}
														</td>
													</ng-container>

													<ng-container *ngSwitchCase="'trigger'">
														<td *ngIf="column.checked">
														  <span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getKey(client, column) }}</span>
														</td>
													</ng-container>

													<ng-container *ngSwitchCase="'type'">
														<td *ngIf="column.checked" [matTooltip]="getKey(client, column)">
															<span [ngClass]="{'need-attention-activity-status': getKey(client, column) == 'Retention', 'new-leads-activity-status': getKey(client, column) == 'Client Engagement', 'in-progress-activity-status': getKey(client, column) == 'Opportunity'}">{{getKey(client, column)}}</span>
														</td>
													</ng-container>

													<ng-container *ngSwitchDefault>
														<td *ngIf="column.checked">
															{{ getKey(client, column) }}
														</td>
													</ng-container>
												</ng-container>
											</tr>
											<tr *ngIf="show_activity_view == clientIndex">
												<td colspan="10" class="page-inner-view" style="overflow: visible;">
													<ng-container *ngIf="type != 'Upside Opportunities MAGI' && type != 'Retention Opportunities MAGI' && type != 'Bank Customers to Investment Clients MAGI' && type != 'New Prospects MAGI' && type != 'Bank Customers to Deposit Clients MAGI' && type != 'Non Customers MAGI' && type != 'Marketing Team Bank Customers to Investment Clients Unassigned' && type != 'Marketing Team New Prospects Unassigned' && type != 'Marketing Team New Prospects - Investments Unassigned' && type != 'Marketing Team Bank Customers to Deposit Clients Unassigned' && type != 'Marketing Team Non Customers Unassigned' && type != 'Marketing Team New Prospects - Deposits Unassigned' && type != 'Marketing Team Bank Customers to Lending Clients Unassigned' && type != 'Marketing Team New Prospects - Lending Unassigned' && type != 'Marketing Team Bank Customers to Insurance Clients Unassigned' && type != 'Marketing Team New Prospects - Insurance Unassigned'">
														<ng-container *ngIf="stepper_stage.position != 'last'">
															<ng-container *ngIf="type == 'Retention Opportunities'">
																<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="3" [selected_view_type]="'Edit'" [activity_action_type]="'Edit'" [stepper_stage]="stepper_stage" [section_type]="stepper_stage.type" (dataChanged)="changeStepper()"></app-activities>
															</ng-container>
															<ng-container *ngIf="type != 'Retention Opportunities'">
																<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="2" [selected_view_type]="'Edit'" [activity_action_type]="'Edit'" [stepper_stage]="stepper_stage" [section_type]="stepper_stage.type" (dataChanged)="changeStepper()"></app-activities>
															</ng-container>
														</ng-container>
														<ng-container *ngIf="stepper_stage.position == 'last'">
															<app-activities [selected_user_data]="client" [selected_page_action]="'Products'" [selected_activity_type]="2" [selected_view_type]="'Edit'" [activity_action_type]="'Edit'" [stepper_stage]="stepper_stage" [section_type]="stepper_stage.type" (dataChanged)="changeStepper()"></app-activities>
														</ng-container>
													</ng-container>
													<ng-container *ngIf="type == 'Upside Opportunities MAGI' || type == 'Retention Opportunities MAGI' || type == 'Bank Customers to Investment Clients MAGI' || type == 'New Prospects MAGI' || type == 'Bank Customers to Deposit Clients MAGI' || type == 'Non Customers MAGI'">
														<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="2" [selected_view_type]="'View'" [section_type]="'ai_assistant'" [activity_action_type]="'View'" (dataChanged)="changeStepper()"></app-activities>
													</ng-container>
													<ng-container *ngIf="(type == 'Marketing Team Bank Customers to Investment Clients Unassigned') || (type == 'Marketing Team New Prospects Unassigned') || (type == 'Marketing Team New Prospects - Investments Unassigned') || (type == 'Marketing Team Bank Customers to Deposit Clients Unassigned') || (type == 'Marketing Team Non Customers Unassigned') || (type == 'Marketing Team New Prospects - Deposits Unassigned') || (type == 'Marketing Team Bank Customers to Lending Clients Unassigned') || (type == 'Marketing Team New Prospects - Lending Unassigned') || (type == 'Marketing Team Bank Customers to Insurance Clients Unassigned') || (type == 'Marketing Team New Prospects - Insurance Unassigned')">
														<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="2" [selected_view_type]="'View'" [section_type]="'ai_assistant'" [activity_action_type]="'View'" (dataChanged)="changeStepper()"></app-activities>
													</ng-container>
												</td>
											</tr>
											<tr *ngIf="show_proposal_view == clientIndex">
												<td colspan="6" class="page-inner-view" style="overflow: visible;">
													<ng-container *ngIf="proposals_list_loaded">
														<div class="page-inner-table-section">
															<table class="page-inner-table">
																<thead>
																	<tr>
																		<th appColumnResizable>Actions</th>
																		<th appColumnResizable>Document Sent Date</th>
																		<th appColumnResizable>Product</th>
																		<th appColumnResizable>Objective</th>
																		<!-- <th appColumnResizable>Status</th> -->
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let proposal of proposals_list">
																		<td>
																			<img src="assets/view-tasks.png" class="client-table-icon" (click)="viewProposal(proposal)" style="margin-right: 4px;" [matTooltip]="'View Document'" />
																			<!-- <img src="assets/resend-proposal.png" class="client-table-icon" (click)="openSendProposalModal('Resend', proposal)" style="margin-right: 4px;" [matTooltip]="'Resend Document'" /> -->
																		</td>
																		<td>{{proposal.proposal_sent_date | date: "dd MMM yyyy"}}</td>
																		<td>{{proposal.objective}}</td>
																		<td>{{proposal.product_name}}</td>
																		<!-- <td>
																			<span class="activity-table-tag" [ngClass]="{'high-importance-tag': proposal.proposal_status == 1, 'medium-importance-tag': proposal.proposal_status == 2, 'low-importance-tag': proposal.proposal_status == 3}">{{proposal.proposal_status_name}}</span>
																		</td> -->
																	</tr>
																	<tr>
																		<td colspan="4">
																			<button class="page-modal-primary-button" (click)="openSendProposalModal('Send', client)">Send Document</button>
																		</td>
																	</tr>
																</tbody>
															</table>
														</div>
													</ng-container>
													<ng-container *ngIf="!proposals_list_loaded">
														<app-loader [loading_text]="'Loading Documents'"></app-loader>
													</ng-container>
												</td>
											</tr>
										</ng-container>
									</tbody>
									<tbody *ngIf="table_data.length == 0">
										<td colspan="15">
											<div class="new-table-v2-zero-section">
												<!-- <img src="assets/no-data-table.png" /> -->
												<p class="new-table-v2-zero-label">No Data Found</p>
											</div>
										</td>
									</tbody>
								</ng-container>
								<ng-container *ngIf="!table_data_loaded">
									<tbody>
										<tr>
											<td colspan="15">
												<app-loader [loading_text]="'Loading Data'"></app-loader>
											</td>
										</tr>
									</tbody>
								</ng-container>
							</table>
						</div>
						<div class="new-table-v2-pagination-section">
							<span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
							<ng-container *ngIf="table_data.length > 0">
								<mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; getTableData()">
									<mat-option [value]="10">10</mat-option>
									<mat-option [value]="100">100</mat-option>
									<mat-option [value]="500">500</mat-option>
									<mat-option [value]="1000">1000</mat-option>
								</mat-select>
								<div class="new-table-v2-pagination-controls">
									<pagination-controls id="interactions-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="!page_summary_data_loaded">
	<app-loader [loading_text]="'Loading Data'"></app-loader>
</ng-container>


<!-- Move Record Modal HTML -->
<ng-template #moveRecordModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Change Stage</span>
			<span class="client-modal-icon" (click)="closeMoveRecordModal()">&times;</span>
		</div>
		<div class="modal-content-section" style="padding: 24px 0;">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Select Stage</p>
				<mat-select class="page-modal-input" [(ngModel)]="move_record_stage">
					<mat-option [value]="''">Select Stage</mat-option>
					<mat-option *ngFor="let stage of stages_data" [value]="stage.id">{{stage.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="move_record_stage_error">Stage is Required.</p>
			</div>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark Stage Activities as Not Required</mat-checkbox>
			</div>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="changeClientStage()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeMoveRecordModal()">Cancel</button>
		</div>
	</div>
</ng-template>


<ng-template #clientDataModal>
	<div class="modal-section client-details-modal">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Know Your {{selected_modal_user_type}}</span>
			<span class="client-modal-icon" (click)="closeClientDataModal()">&times;</span>
		</div>
		<div class="modal-content-section" *ngIf="!selected_modal_user_loader">
			<ng-container *ngIf="selected_modal_user_type == 'Client'">
				<app-client-profile [client_data]="selected_modal_user"></app-client-profile>
			</ng-container>
			<ng-container *ngIf="selected_modal_user_type == 'Lead'">
				<app-prospect-profile [prospect_data]="selected_modal_user"></app-prospect-profile>
			</ng-container>
		</div>
		<div class="modal-content-section" *ngIf="selected_modal_user_loader">
			<app-loader [loading_text]="'Loading Profile'"></app-loader>
		</div>
	</div>
</ng-template>

<ng-template #addOpportunityModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Add to Opportunities</span>
			<span class="client-modal-icon" (click)="closeAddOpportunityModal()">&times;</span>
		</div>
		<div class="modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to add to Opportunities?</p>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="addOpportunity()">Yes</button>
			<button class="page-modal-secondary-button" (click)="closeAddOpportunityModal()">No</button>
		</div>
	</div>
</ng-template>


<ng-container *ngIf="show_user_profile">
	<ng-container *ngIf="user_profile_data_type == 'Client'">
		<app-customer-profile [data]="user_profile_data" [client_type]="'Client'" (profileClosed)="profileClosed($event)"></app-customer-profile>
	</ng-container>
	<ng-container *ngIf="user_profile_data_type == 'Lead'">
		<ng-container *ngIf="user_profile_data.source_type_id != 1 ">
			<app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
		  </ng-container>
		  <ng-container *ngIf="user_profile_data.source_type_id == 1 ">
			<app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
		  </ng-container>
	</ng-container>
</ng-container>


<!-- Send Proposal -->
<ng-template #sendProposalModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Send Document</span>
			<span class="page-modal-close-icon" (click)="closeSendProposalModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Objective *</p>
				<mat-select class="page-modal-input"  [(ngModel)]="proposal_data.objective_code">
					<mat-option [value]="''">Select Objective</mat-option>
					<mat-option *ngFor="let objective of objectives_list" [value]="objective.objective_code">{{objective.objective}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.objective_code">Objective is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Product *</p>
				<mat-select class="page-modal-input"  [(ngModel)]="proposal_data.product">
					<mat-option [value]="''">Select Product</mat-option>
					<mat-option *ngFor="let product of products_list" [value]="product.id">{{product.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.product">Product is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Scheduled Date *</p>
				<input
                  type="text"
                  class="page-modal-input"
                  bsDatepicker
                  [minDate]="current_date"
                  [(ngModel)]="proposal_data.scheduled_date"
                  [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
                />
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.scheduled_date">Scheduled Date is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Upload the Documents *</p>
				<input type="file" multiple style="display: none;" #proposalFile (change)="uploadProposalFile($event)" />
				<!-- <input type="file" style="display: none;" #proposalFile (change)="uploadProposalFile($event)" /> -->
				<button class="page-modal-primary-button" (click)="proposalFile.click()">Upload</button>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.files">File should be minimum one.</p>
				<div class="each-proposal-document-section" *ngFor="let file of proposal_data.files; let index = index">
					<span>{{file.name}}</span>
					<span class="each-proposal-document-remove-icon" (click)="deleteProposalFile(index)">&times;</span>
				</div>
			</div>
			<!-- <div class="page-modal-input-section">
				<p class="page-modal-input-label">Description *</p>
				<app-textarea-tagging
					[value]="proposal_data.description"
					[users]="[]"
					[placeholder]="'Description ...'"
					(valueChanged)="proposal_data.description = $event"
				></app-textarea-tagging>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.description">Description is required.</p>
			</div> -->
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Subject *</p>
				<input type="text" class="page-modal-input" [(ngModel)]="proposal_data.subject" />
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.subject">Subject is required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Email Body *</p>
				<!-- <input type="text" class="page-modal-input" [(ngModel)]="proposal_data.subject" /> -->
				<angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="proposal_data.email_body" [config]="editorConfig"></angular-editor>
				<p class="page-modal-input-error" *ngIf="proposal_data_errors.email_body">Body is required.</p>
			</div>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark pending and in-progress activities as not required.</mat-checkbox>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="sendProposal()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeSendProposalModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<!-- View Proposal -->
<ng-template #viewProposalModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">View Document</span>
			<span class="page-modal-close-icon" (click)="closeViewProposalModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Document Sent Date</p>
				<p class="page-modal-input">{{view_proposal_data.proposal_sent_date | date: 'dd MMM yyyy'}}</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Product</p>
				<p class="page-modal-input">{{view_proposal_data.product_name}}</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Objective</p>
				<p class="page-modal-input">{{view_proposal_data.objective}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Subject</p>
				<p class="page-modal-input">{{view_proposal_data.subject}}</p>
			</div>
            <div class="page-modal-input-section">
				<p class="page-modal-input-label">Email Body</p>
				<p class="page-modal-input" [innerHTML]="view_proposal_data.email_body" style="white-space: normal;"></p>
			</div>
			<!-- <div class="page-modal-input-section">
				<p class="page-modal-input-label">Status</p>
				<span class="activity-table-tag" [ngClass]="{'high-importance-tag': view_proposal_data.proposal_status == 1, 'medium-importance-tag': view_proposal_data.proposal_status == 2, 'low-importance-tag': view_proposal_data.proposal_status == 3}">{{view_proposal_data.proposal_status_name}}</span>
			</div> -->
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Documents</p>
				<div class="each-proposal-document-section" *ngFor="let file of view_proposal_data.documents; let index = index">
					<span>{{file.document_file_name}}</span>
					<!-- <span class="each-proposal-document-remove-icon" (click)="download(file.document)">&#x2193;</span> -->
					<img src="assets/attachment-download.png" class="each-proposal-document-remove-icon" (click)="download(file.document)" />

				</div>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeViewProposalModal()">Close</button>
		</div>
	</div>
</ng-template>


<!-- Close Deal -->
<ng-template #closeDealModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<!-- <span class="modal-heading">Close Deal</span> -->
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="closeClientDealModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Conversion Status *</p>
				<mat-select class="page-modal-input" [(ngModel)]="conversion_status_data.conversion_status" >
					<mat-option [value]="''">Select Conversion Status</mat-option>
					<mat-option *ngFor="let conversion_status of conversion_status_list" [value]="conversion_status.id" (click)=" conversion_status_data.conversion_status_name = conversion_status.name ">{{ conversion_status.name }}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="conversion_status_data_errors.conversion_status">Conversion Status is Required.</p>
			</div>
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Comments *</p>
				<app-textarea-tagging [value]="conversion_status_data.conversion_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="conversion_status_data.conversion_comments = $event"></app-textarea-tagging>
				<p class="page-modal-input-error" *ngIf="conversion_status_data_errors.conversion_comments">Comments is Required.</p>
			</div>
			<ng-container *ngIf="conversion_status_data.conversion_status == 1 && selected_table_data.length != 1">
				<div class="page-modal-input-section">
					<p class="page-modal-input-error">Select only one client to add Product Information</p>
				</div>
			</ng-container>


			<ng-container *ngIf="conversion_status_data.conversion_status == 1">
				<!-- <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container> -->
					<ng-container *ngIf="user_details.role.business_area[0] == 5">
						<ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
					</ng-container>
					<ng-container *ngIf="user_details.role.business_area[0] == 6">
						<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
					</ng-container>
          <ng-container *ngIf="user_details.role.business_area[0] == 7">
						<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
					</ng-container>
          <ng-container *ngIf="user_details.role.business_area[0] == 8">
						<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
					</ng-container>
			</ng-container>

			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark pending and in-progress activities as not required.</mat-checkbox>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="closeDealInformation()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeClientDealModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<!-- Change Outcome -->
<ng-template #changeOutcomeModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<!-- <span class="modal-heading">Change Outcome</span> -->
			<span class="modal-heading">Capture Results</span>
			<span class="page-modal-close-icon" (click)="closeChangeOucomeModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Outcome Status *</p>
				<mat-select class="page-modal-input" [(ngModel)]="outcome_data.attrition_status" >
					<mat-option [value]="''">Select Outcome Status</mat-option>
					<mat-option [value]="'Retained'">Retained</mat-option>
					<mat-option [value]="'Retained, Upside'">Retained, Upside</mat-option>
					<mat-option [value]="'Likely to Switch Advisor'">Likely to Switch Advisor</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="outcome_data_errors.attrition_status">Outcome Status is Required.</p>
			</div>
			<div class="page-modal-input-section" *ngIf="outcome_data.attrition_status == 'Likely to Switch Advisor'">
				<p class="page-modal-input-label">Reason *</p>
				<mat-select class="page-modal-input" [(ngModel)]="outcome_data.attrition_comments" >
					<mat-option [value]="''">Select Reason</mat-option>
					<mat-option *ngFor="let attrition_reason of attrition_reasons_list" [value]="attrition_reason.name">{{attrition_reason.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="outcome_data_errors.attrition_comments">Reason is Required.</p>
			</div>
			<div class="page-modal-input-section" *ngIf="outcome_data.attrition_status != 'Likely to Switch Advisor'">
				<p class="page-modal-input-label">Comments *</p>
				<app-textarea-tagging [value]="outcome_data.attrition_comments" [users]="tagging_users_list" [placeholder]="'Comments ...'" (valueChanged)="outcome_data.attrition_comments = $event"></app-textarea-tagging>
				<p class="page-modal-input-error" *ngIf="outcome_data_errors.attrition_comments">Comments is Required.</p>
			</div>
			<ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside' && selected_table_data.length != 1">
				<div class="page-modal-input-section">
					<p class="page-modal-input-error">Select only one client to add Product Information</p>
				</div>
			</ng-container>
			<ng-container *ngIf="outcome_data.attrition_status == 'Retained, Upside' && selected_table_data.length == 1">
				<!-- <ng-container *ngTemplateOutlet="productOperationSection;"></ng-container> -->
				<ng-container *ngIf="user_details.role.business_area[0] == '5'">
					<ng-container *ngTemplateOutlet="productOperationSection;"></ng-container>
				</ng-container>
				<ng-container *ngIf="user_details.role.business_area[0] == '6'">
					<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
				</ng-container>
        <ng-container *ngIf="user_details.role.business_area[0] == '7'">
					<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
				</ng-container>
        <ng-container *ngIf="user_details.role.business_area[0] == '8'">
					<ng-container *ngTemplateOutlet="depositProductOperationSection;"></ng-container>
				</ng-container>
			</ng-container>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark pending and in-progress activities as not required.</mat-checkbox>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="changeOutcome()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeChangeOucomeModal()">Cancel</button>
		</div>
	</div>
</ng-template>


<ng-template #productOperationSection>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label" *ngIf="user_role != 'Relationship Manager'">Policy Number *</p>
		<p class="page-modal-input-label" *ngIf="user_role == 'Relationship Manager'">Deposit Number *</p>
		<input type="text" class="page-modal-input" [(ngModel)]="product_data.policy_number" />
		<p class="page-modal-input-error" *ngIf="product_data_errors.policy_number">
			<span *ngIf="user_role != 'Relationship Manager'">Policy Number</span>
			<span *ngIf="user_role == 'Relationship Manager'">Deposit Number</span>
			is Required.
		</p>
	</div>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label">AUM *</p>
		<input type="text" class="page-modal-input" [(ngModel)]="product_data.aum" (keypress)="numberOnly($event)" />
		<p class="page-modal-input-error" *ngIf="product_data_errors.aum">AUM is Required.</p>
	</div>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label">Product *</p>
		<mat-select class="page-modal-input" [(ngModel)]="product_data.product">
			<mat-option [value]="''">Select Product</mat-option>
			<mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(product_data.product)" >{{ product.name }}</mat-option>
		</mat-select>
		<p class="page-modal-input-error" *ngIf="product_data_errors.product">Product is Required.</p>
	</div>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label">Activated Date *</p>
		<input
			type="text"
			class="page-modal-input"
			bsDatepicker
			placement="right"
			[(ngModel)]="product_data.start_date"
			[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
		/>
		<p class="page-modal-input-error" *ngIf="product_data_errors.start_date">Activated Date is Required.</p>
	</div>
	<div class="page-modal-input-section" *ngIf="getProductType(product_data.product)">
		<p class="page-modal-input-label">Valid Until *</p>
		<input
			type="text"
			class="page-modal-input"
			bsDatepicker
			placement="right"
			[(ngModel)]="product_data.close_date"
			[minDate]="product_data.start_date"
			[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
		/>
		<!-- [disabled]="product_data.start_date == '' || product_data.start_date == null" -->
		<p class="page-modal-input-error" *ngIf="product_data_errors.start_date">Valid Until is Required.</p>
	</div>
	<div class="page-modal-input-section" *ngIf="user_role == 'Relationship Manager'">
		<p class="page-modal-input-label">Purpose *</p>
		<mat-select class="page-modal-input" [(ngModel)]="product_data.deposit_purpose">
			<mat-option [value]="''">Select Purpose</mat-option>
                <mat-option [value]="'Emergency Fund'">Emergency Fund</mat-option>
                <mat-option [value]="'Short-Term Goals'">Short-Term Goals</mat-option>
                <mat-option [value]="'Long-Term Savings'">Long-Term Savings</mat-option>
                <mat-option [value]="'Education Expenses'">Education Expenses</mat-option>
                <mat-option [value]="'Retirement Savings'">Retirement Savings</mat-option>
                <mat-option [value]="'Building Wealth'">Building Wealth</mat-option>
                <mat-option [value]="'Income Generation'">Income Generation</mat-option>
                <mat-option [value]="'Estate Planning'">Estate Planning</mat-option>
                <mat-option [value]="'Tax Payments'">Tax Payments</mat-option>
                <mat-option [value]="'Business Operations'">Business Operations</mat-option>
		</mat-select>
		<p class="page-modal-input-error" *ngIf="product_data_errors.deposit_purpose">Purpose is Required.</p>
	</div>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label">Type *</p>
		<mat-select class="page-modal-input" [(ngModel)]="product_data.type">
			<mat-option [value]="''">Select Type</mat-option>
			<!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
			<mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
			<mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
			<mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
			<mat-option [value]="'Upside'">Upside</mat-option>
			<mat-option [value]="'Retention'">Retention</mat-option>
		</mat-select>
		<p class="page-modal-input-error" *ngIf="product_data_errors.type">Type is Required.</p>
	</div>
	<div class="page-modal-input-section">
		<p class="page-modal-input-label">Client Product Status *</p>
		<mat-select class="page-modal-input" [(ngModel)]="product_data.client_product_status">
			<mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
		</mat-select>
		<p class="page-modal-input-error" *ngIf="product_data_errors.client_product_status">Client Product Status is Required.</p>
	</div>
</ng-template>



<!-- deposit Product Operation Section Start -->
<ng-template #depositProductOperationSection>
  <div>
        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Product *</p>
            <mat-select class="page-modal-input" [(ngModel)]="depositProduct_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(depositProduct_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.product">Product is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Policy Number *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="depositProduct_data.policy_number" />
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.policy_number">Policy Number  is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Amount *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="depositProduct_data.aum" (input)="checkAmountValidation(depositProduct_data.product, depositProduct_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.aum">Amount is Required.</p>
			<p class="page-modal-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Start Date *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Valid Until *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="depositProduct_data.close_date"
				[minDate]="depositProduct_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"

            />
			<!-- [disabled]="depositProduct_data.start_date == '' || depositProduct_data.start_date == null" -->
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Interest Rate (%) *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="depositProduct_data.interest_rate" (keypress)="validateMaxValue($event, 100)"
			/>
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Monthly Fees *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="depositProduct_data.monthly_fees" />
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Type *</p>
            <mat-select class="page-modal-input" [(ngModel)]="depositProduct_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.type">Type is Required.</p>
        </div>



        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Client Product Status *</p>
            <mat-select class="page-modal-input" [(ngModel)]="depositProduct_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="depositProduct_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- deposit Product Operation Section End -->

<!-- Lending Product Operation Section Start -->
<ng-template #lendingProductOperationSection>
  <div>
        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Product *</p>
            <mat-select class="page-modal-input" [(ngModel)]="lending_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(lending_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Policy Number *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="lending_product_data.policy_number" />
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.policy_number">Policy Number  is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Amount *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="lending_product_data.aum" (input)="checkAmountValidation(lending_product_data.product, lending_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.aum">Amount is Required.</p>
			<p class="page-modal-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Start Date *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Valid Until *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="lending_product_data.close_date"
				[minDate]="lending_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"

            />
			<!-- [disabled]="lending_product_data.start_date == '' || lending_product_data.start_date == null" -->
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Interest Rate (%) *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="lending_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)"
			/>
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Monthly Fees *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="lending_product_data.monthly_fees" />
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Type *</p>
            <mat-select class="page-modal-input" [(ngModel)]="lending_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Client Product Status *</p>
            <mat-select class="page-modal-input" [(ngModel)]="lending_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="lending_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Lending Product Operation Section End -->

<!-- Insurance Product Operation Section Start -->
<ng-template #insuranceProductOperationSection>
  <div>
        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Product *</p>
            <mat-select class="page-modal-input" [(ngModel)]="insurance_product_data.product">
                <mat-option [value]="''">Select Product</mat-option>
                <mat-option *ngFor="let product of product_list" [value]="product.id" (click)="getProductType(insurance_product_data.product)" >{{ product.name }}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.product">Product is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Policy Number *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="insurance_product_data.policy_number" />
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.policy_number">Policy Number  is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Amount *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="insurance_product_data.aum" (input)="checkAmountValidation(insurance_product_data.product, insurance_product_data.aum)" (keypress)="numberOnly($event)" />
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.aum">Amount is Required.</p>
			<p class="page-modal-input-error" *ngIf="min_amount_error">{{min_amount_error_text}}</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Start Date *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
            />
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.start_date">Activated Date is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Valid Until *</p>
            <input
                type="text"
                class="page-modal-input"
                bsDatepicker
                placement="right"
                [(ngModel)]="insurance_product_data.close_date"
				[minDate]="insurance_product_data.start_date"
                [bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"

            />
			<!-- [disabled]="insurance_product_data.start_date == '' || insurance_product_data.start_date == null" -->
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.close_date">Valid Until is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Interest Rate (%) *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="insurance_product_data.interest_rate" (keypress)="validateMaxValue($event, 100)"
			/>
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.interest_rate">Interest Rate (%) is Required.</p>
        </div>

        <div class="page-modal-input-section">
            <p class="page-modal-input-label" >Monthly Fees *</p>
            <input type="text" class="page-modal-input" [(ngModel)]="insurance_product_data.monthly_fees" />
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.monthly_fees">Monthly Fees is Required.</p>
        </div>


        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Type *</p>
            <mat-select class="page-modal-input" [(ngModel)]="insurance_product_data.type">
                <mat-option [value]="''">Select Type</mat-option>
                <!-- <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
                <mat-option [value]="'Up-Sell'">Up-Sell</mat-option> -->
                <mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
                <mat-option [value]="'Upside'">Upside</mat-option>
                <mat-option [value]="'Retention'">Retention</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.type">Type is Required.</p>
        </div>



        <div class="page-modal-input-section">
            <p class="page-modal-input-label">Client Product Status *</p>
            <mat-select class="page-modal-input" [(ngModel)]="insurance_product_data.client_product_status">
                <mat-option [value]="''">Select Product Status</mat-option>
                <mat-option *ngFor="let status of client_product_status_list" [value]="status.id">{{status.name}}</mat-option>
            </mat-select>
            <p class="page-modal-input-error" *ngIf="insurance_product_data_errors.client_product_status"> Client Product Status is Required.</p>
        </div>
    </div>
</ng-template>
<!-- Insurance Product Operation Section End -->

<ng-template #syncActivitiesModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Syncing Activities</span>
			<!-- <span class="client-modal-icon" (click)="closeSyncActivitiesModal()">&times;</span> -->
		</div>
		<div class="modal-content-section">
			<div class="page-modal-delete-description">
				<div>
					<img src="assets/sync-icon.png" class="rotating-image" />
				</div>
				<span>Syncing In Progress ...</span>
			</div>
		</div>
	</div>
</ng-template>

<!-- Assign Advisor -->
<ng-template #assignAdvisorModal>
	<div class="page-modal-section">
		<div class="page-modal-heading-section client-view-heading-section">
			<span class="modal-heading">Assign Advisor</span>
			<span class="page-modal-close-icon" (click)="closeAssignAdvisorModal()">&times;</span>
		</div>
		<div class="page-modal-content-section">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Advisor *</p>
				<mat-select class="page-modal-input"  [(ngModel)]="assign_advisor">
					<mat-option [value]="''">Select Advisor</mat-option>
					<mat-option *ngFor="let advisor of advisor_list" [value]="advisor.id">{{advisor.first_name}} {{advisor.last_name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="assign_advisor_error">Advisor is required.</p>
			</div>
		</div>
		<div class="page-modal-footer-section">
			<button class="page-modal-primary-button" (click)="assignAdvisor()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeAssignAdvisorModal()">Cancel</button>
		</div>
	</div>
</ng-template>


<!-- Assign Advisor Team Modal -->
<ng-template #createAdvisorTeamModal>
  <div class="page-modal-section">
    <div class="page-modal-heading-section client-view-heading-section">
      <span class="modal-heading">Assign Advisor Team</span>
      <span class="page-modal-close-icon" (click)="closeCreateAdvisorTeamModal()">&times;</span>
    </div>
    <div class="page-modal-content-section">
      <div class="page-modal-input-section">
        <p class="page-modal-input-label">Select Team *</p>
        <mat-select class="page-modal-input"  [(ngModel)]="selected_advisor_team.id">
          <mat-option *ngFor="let advisor_team of advisor_teams_list" [value]="advisor_team.id" (click)="resetAdvisorTeamData(); selected_advisor_team = advisor_team;">{{advisor_team.name}}</mat-option>
          <mat-option [value]="'New Team'" (click)="resetAdvisorTeamData(); selected_advisor_team.id = 'New Team'">+ Create New Team</mat-option>
        </mat-select>
        <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.id">Team is required.</p>
      </div>
      <ng-container *ngIf="selected_advisor_team.id != ''">
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Team Name *</p>
          <input type="text" class="page-modal-input" [(ngModel)]="selected_advisor_team.name" [disabled]="selected_advisor_team.id != 'New Team'" />
          <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.name">Team Name is required</p>
        </div>
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Description </p>
          <textarea class="page-modal-input page-modal-textarea" [(ngModel)]="selected_advisor_team.description" [disabled]="selected_advisor_team.id != 'New Team'"></textarea>
          <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.description">Description is required</p>
        </div>
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Primary Advisor *</p>
          <mat-select class="page-modal-input"  [(ngModel)]="selected_advisor_team.primary_advisor_id" (selectionChange)="segregateOtherAdvisors()" [disabled]="selected_advisor_team.id != 'New Team'">
            <mat-option [value]="''">Select Primary Advisor</mat-option>
            <mat-option *ngFor="let advisor of advisor_list" [value]="advisor.id">{{advisor.first_name}} {{advisor.last_name}} : (Remaining Capacity - {{advisor.capacity_remaining}})</mat-option>
          </mat-select>
          <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.primary_advisor_id">Primary Advisor is required.</p>
        </div>
        <div class="page-modal-input-section">
          <p class="page-modal-input-label">Primary Advisor Share(%) *</p>
          <input type="text" class="page-modal-input" [(ngModel)]="selected_advisor_team.share_percentage" (keypress)="numberOnly($event)" [disabled]="selected_advisor_team.id != 'New Team'" />
          <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.share_percentage">Primary Advisor Share(%) is required & should be equal to 100.</p>
        </div>
        <ng-container *ngIf="selected_advisor_team.primary_advisor_id != ''">
          <div class="other-advisors-heading-section">
            <span>Other Advisors</span>
          </div>
          <p class="page-modal-input-error" *ngIf="selected_advisor_team_errors.team_members">Select at least one advisor, and enter a share(%) should be equal to 100.</p>
          <table class="page-inner-table">
            <thead>
              <tr>
                <th>Advisor</th>
                <th>Share(%)</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let advisor of selected_advisor_team.team_members">
                <td>
                  <mat-checkbox [(ngModel)]="advisor.checked"  [disabled]="selected_advisor_team.id != 'New Team'">{{advisor.advisor_name}}</mat-checkbox>
                </td>
                <td>
                  <input type="text" class="page-modal-input" [(ngModel)]="advisor.share_percentage" (keypress)="numberOnly($event)" [disabled]="!advisor.checked || selected_advisor_team.id != 'New Team'" />
                </td>
              </tr>
            </tbody>
          </table>
        </ng-container>
      </ng-container>

    </div>
    <div class="page-modal-footer-section">
      <ng-container *ngIf="!assign_advisor_team_loader">
        <button class="page-modal-primary-button" (click)="assignAdvisorTeam()">Save</button>
        <button class="page-modal-secondary-button" (click)="closeCreateAdvisorTeamModal()">Cancel</button>
      </ng-container>
      <ng-container *ngIf="assign_advisor_team_loader">
        <button class="page-modal-primary-button" (click)="assignAdvisorTeam()">Saving...</button>
      </ng-container>
    </div>
  </div>
</ng-template>
